export default __webpack_public_path__ + "images/c2c365b382c186c9b3d3065d947e10aa-alternative_music_small.webp";